// Copyright (c) 2016 Deere & Company

import CourierInfo, {getDefaultState as getDefaultCourierInfoState} from './courier-info';
import Dealer, {getDefaultState as getDefaultDealerState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ReturnStatus, {getDefaultState as getDefaultReturnStatusState} from './return-status';
import ShipToLocation, {getDefaultState as getDefaultShipToLocationState} from './ship-to-location';
import AllowedReturnStatus from './allowed-return-status';
import File from './file';
import OtherInstruction from './other-instruction';
import PartReturnQuestion from './part-return-question';
import SpecialInstruction from './special-instruction';
import t from 'tcomb';

const PartReturn = t.struct({
    account: Dealer,
    allowedReturnStatuses: t.list(AllowedReturnStatus, 'AllowedReturnStatuses'),
    claimNumber: t.String,
    courierInfo: CourierInfo,
    daysLeft: t.Number,
    dispatchDate: t.maybe(t.Number),
    dtac: t.maybe(t.String),
    dtacUrl: t.maybe(t.String),
    files: t.maybe(t.list(File, 'Files')),
    firstShipToLocation: ShipToLocation,
    id: t.String,
    isShipmentPriorityHigh: t.Boolean,
    otherInstructions: t.list(OtherInstruction, 'OtherInstructions'),
    partDescription: t.maybe(t.String),
    partNumber: t.String,
    partQuantity: t.Number,
    pin: t.maybe(t.String),
    questions: t.maybe(t.list(PartReturnQuestion)),
    reference1: t.maybe(t.String),
    requestDate: t.Number,
    requestType: KeyValuePair,
    returnStatus: ReturnStatus,
    rgaNumber: t.String,
    secondShipToLocation: ShipToLocation,
    specialInstructions: t.list(SpecialInstruction, 'SpecialInstructions')
}, {
    name: 'PartReturn',
    strict: true
});

export const getDefaultState = () => new PartReturn({
    account: getDefaultDealerState(),
    allowedReturnStatuses: [],
    claimNumber: '',
    courierInfo: getDefaultCourierInfoState(),
    daysLeft: 0,
    dispatchDate: 0,
    files: [],
    firstShipToLocation: getDefaultShipToLocationState(),
    id: '',
    isShipmentPriorityHigh: false,
    otherInstructions: [],
    partNumber: '',
    partQuantity: 0,
    requestDate: 0,
    requestType: getKeyValuePairDefaultState(),
    returnStatus: getDefaultReturnStatusState(),
    rgaNumber: '',
    secondShipToLocation: getDefaultShipToLocationState(),
    specialInstructions: []
});

PartReturn.prototype.stripLeadingZerosForRgaNumber = function stripLeadingZerosForRgaNumber() {

    const strippedRgaNumber = this.rgaNumber.replace(/^0+/, '');

    return strippedRgaNumber;

};

export default PartReturn;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/part-return.js